import { oneLine } from 'common-tags';

import { Text } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeFeaturedTextProps } from './types';

/**
 * FeaturedText
 */
export const FeaturedText: FunctionComponent<TypeFeaturedTextProps> = ({
  className = '',
  Icon,
  children,
  text,
  textStyleClass,
  background = 'bg-primary-50',
}: TypeFeaturedTextProps) => (
  <div
    className={oneLine`rounded-custom ${background} flex flex-row items-center gap-4 py-4 pr-4 pl-2 md:justify-center ${className} `}
  >
    <Icon width={64} height={64} className="shrink-0" />

    <div className="flex flex-col justify-between gap-4 md:w-full md:flex-row md:items-center">
      <Text
        className={oneLine`text-body font-bold ${
          textStyleClass ?? 'text-body-m md:text-headline md:text-headline-h4'
        }`}
      >
        {text}
      </Text>

      {children}
    </div>
  </div>
);

FeaturedText.displayName = 'FeaturedText';
